import { getApiUrl } from '@/api/apiClient';

const BASE = '/api/files';

export default {
  getAll: () => getApiUrl(`${BASE}`),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  getContentById: (id) => getApiUrl(`${BASE}/${id}/content`),
};
